import { LoginPayload } from '@oare/types';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '@/firebase';

async function login(payload: LoginPayload): Promise<void> {
  await signInWithEmailAndPassword(auth, payload.email, payload.password);
}

export default {
  login,
};
